import type { TQuestionRule } from 'types/rules.types';
import { DEFAULT_EARLY_REJECT_QUESTION_ID } from '../constants';

// No persisted marker distinguishes an auto-generated rule from a hand-authored one — this
// structural match (single option-condition, single JUMP_TO action targeting the bridge question)
// is the only signal, so it's deliberately narrow: any extension no longer matches.
export function findAutoEarlyRejectRule(rules: TQuestionRule[], optionId: string): TQuestionRule | undefined {
  return rules.find((rule) => {
    if (rule.conditions.length !== 1 || rule.conditions[0]?.value !== optionId) {
      return false;
    }
    if (rule.actions?.length !== 1) {
      return false;
    }
    const action = rule.actions[0];
    if (action.name !== 'JUMP_TO') {
      return false;
    }
    return action.value.some((value) => typeof value !== 'string' && value.id === DEFAULT_EARLY_REJECT_QUESTION_ID);
  });
}
